module.exports = __webpack_public_path__ + "img/img-a739757d.795bdd72.png";